import { Controller } from '@hotwired/stimulus';
import { waitForRoundAnimation } from '../lib/round_animation.js';

export default class extends Controller {
  static targets = ['character'];
  static values = { horizontal: Boolean };

  initialize() {
    this.characterFrameLoaded = this.characterFrameLoaded.bind(this);
    this.activeCharacters = new WeakSet();
  }

  connect() {
    this.manualScroll = () => { this.manuallyScrolled = true; };
    this.manualEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    this.manualEvents.forEach(name => this.element.addEventListener(name, this.manualScroll, { passive: true }));
  }

  disconnect() {
    this.manualEvents.forEach(name => this.element.removeEventListener(name, this.manualScroll));
  }

  characterTargetConnected(element) {
    this.centerCharacterIfActive(element);
    element.addEventListener('turbo:morph-element', this.characterFrameLoaded);
  }

  characterFrameLoaded(event) {
    if (event.target === event.currentTarget) this.centerCharacterIfActive(event.target);
  }

  async centerCharacterIfActive(element) {
    if (!this.horizontalValue) {
      await waitForRoundAnimation(element);
      if (!element.isConnected) return;
    }
    if (element.hasAttribute('data-character-reveal-phase')) return;
    if (this.horizontalValue) {
      const wasActive = this.activeCharacters.has(element);
      if (element.dataset.characterActive !== 'true') {
        this.activeCharacters.delete(element);
        return;
      }
      this.activeCharacters.add(element);
      if (wasActive || this.manuallyScrolled || this.element.scrollWidth <= this.element.clientWidth) return;

      const character = element.getBoundingClientRect();
      const container = this.element.getBoundingClientRect();
      const left = container.left + this.element.clientLeft;
      const right = left + this.element.clientWidth;

      this.element.scrollTo({
        left: this.element.scrollLeft + (character.left + character.right - left - right) / 2,
        behavior: 'smooth'
      });
      return;
    }

    if (element.classList.contains("active_turn")) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
  }

  characterTargetDisconnected(element) {
    element.removeEventListener('turbo:morph-element', this.characterFrameLoaded);
    this.activeCharacters.delete(element);
  }
}
